<div class="my-3">
  <h5 *ngIf="componentCurrCd == 'DEFAULT'">Default</h5>
  <ng-container *ngIf="componentCurrCd != 'DEFAULT'">
    <div class="d-inline-block mr-1">
      <h5>{{visuals?.workflowForCurr}}</h5>
    </div>
    <div class="d-inline-block mr-1">
      <ng-select
        class="dynamic-form-field__field--select"
        id="currCdSelect"
        name="currCdSelect"
        [clearable]="false"
        [items]="componentAvailableCurrencies"
        (change)="changeComponentSelectedCurrCd($event)"
        [(ngModel)]="this.componentCurrCd"
        [readonly]="isReadOnly"
        appendTo="body"
        bindValue="text"
        bindLabel="text"
        style="width:6em;"
      ></ng-select>
    </div>
  </ng-container>
  <form [formGroup]="currTierForm">
    <div class="row" formArrayName="tiers">
      <div class="col-12">
        <div class="table-responsive">
          <table class="dynamic-grid__table table table-striped table-hover table-sm condensed">
            <thead class="dynamic-grid__table-header">
              <tr class="dynamic-grid__table-header-row text-brand-primary-1">
                <th class="dynamic-grid__table-header-col"></th>
                <th class="dynamic-grid__table-header-col">#</th>
                <th class="dynamic-grid__table-header-col">
                  {{visuals?.minAmount}}
                </th>
                <th class="dynamic-grid__table-header-col">
                  {{visuals?.maxAmount}}
                </th>
                <th class="dynamic-grid__table-header-col">
                  {{visuals?.workflow}}
                </th>
                <th class="dynamic-grid__table-header-col"></th>
              </tr>
            </thead>
            <tbody class="dynamic-grid__table-body">
              <tr
                *ngFor="let tierItem of currTierForm.get('tiers')['controls']; let i = index;"
                [formGroupName]="i"
                class="dynamic-grid__table-body-row"
              >
                <td class="dynamic-grid__table-body-col--count centered-content">
                  <i
                    *ngIf="i > 0 && !isReadOnly"
                    class="mdi mdi-minus-circle-outline mdi-16px"
                    tooltip="Remove Tier"
                    (click)="removeTiersClick(i)"
                  ></i>
                </td>
                <td class="dynamic-grid__table-body-col--count">
                  {{i+1}}
                </td>
                <td class="dynamic-grid__table-body-col--count">
                  <div *ngIf="i > 0">
                    <input
                      name="minAmount"
                      currencyMask
                      class="dynamic-form-field__field--currency form-control"
                      (blur)="minAmountChangedClick(i)"
                      onkeyup="if(this.value<0){this.value= this.value * -1}"
                      [readonly]="isReadOnly"
                      formControlName="minAmount"
                      type="tel"
                    />
                    <div *ngIf="!tierItem.value.minAmount" class="dynamic-form-field__validation--input">
                      <p class="dynamic-form-field__validation-text--input text-danger font-sm mb-0" role="alert">
                        {{genericVisuals?.required}}
                      </p>
                    </div>
                  </div>
                  <div *ngIf="i == 0">
                    <input
                      name="minAmount"
                      currencyMask
                      class="dynamic-form-field__field--currency form-control"
                      formControlName="minAmount"
                      [readonly]="isReadOnly"
                      type="tel"
                      value="0"
                    />
                  </div>
                </td>
                <td class="dynamic-grid__table-body-col--count">
                  <div *ngIf="i != (editForm.controls['policyConfig'].controls['tiers'].controls.length -1)">
                    <input
                      name="maxAmount"
                      currencyMask
                      class="dynamic-form-field__field--currency form-control"
                      formControlName="maxAmount"
                      (blur)="maxAmountChangedClick(i)"
                      [readonly]="isReadOnly"
                      onkeyup="if(this.value<0){this.value= this.value * -1}"
                      type="tel"
                    />
                    <div *ngIf="!tierItem.value.maxAmount" class="dynamic-form-field__validation--input">
                      <p class="dynamic-form-field__validation-text--input text-danger font-sm mb-0" role="alert">
                        {{genericVisuals?.required}}
                      </p>
                    </div>
                  </div>
                  <div *ngIf="i == (editForm.controls['policyConfig'].controls['tiers'].controls.length -1)">
                    <input
                      name="maxAmount"
                      currencyMask
                      [options]="customCurrencyConfig"
                      class="dynamic-form-field__field--currency form-control"
                      formControlName="maxAmount"
                      (blur)="maxAmountChangedClick(i)"
                      onkeyup="if(this.value<0){this.value = this.value * -1}"
                      [readonly]="isReadOnly"
                      type="tel"
                    />
                  </div>
                </td>
                <td class="dynamic-grid__table-body-col--count" formGroupName="workflow">
                  <div
                    class="row m-0"
                    *ngFor="let workflowItem of tierItem.controls['workflow'].controls; let j = index; let len = count; let lst = last; let isFirst = first;"
                    [ngClass]="{'py-1': !isFirst}"
                    [formGroupName]="j"
                  >
                    <span class="col-sm-7">
                      <ng-select
                        class="dynamic-form-field__field--select"
                        bindLabel="controls.groupVisual.value"
                        bindValue="controls.groupId.value"
                        formControlName="groupId"
                        [clearable]="false"
                        appendTo="body"
                        [readonly]="isReadOnly"
                        [items]="editForm.controls['policyConfig'].controls['groups'].controls"
                        (change)="tierUpdatedEvent(i)"
                      ></ng-select>
                      <div *ngIf="!workflowItem.value.groupId" class="dynamic-form-field__validation--input">
                        <p class="dynamic-form-field__validation-text--input text-danger font-sm mb-0" role="alert">
                          {{genericVisuals?.required}}
                        </p>
                      </div>
                    </span>

                    <span class="col-sm-2 centered-content">
                      <input
                        class="dynamic-form-field__field--input form-control"
                        type="number"
                        min="0"
                        onkeypress="return event.charCode >= 48"
                        step="1"
                        formControlName="count"
                        [readonly]="isReadOnly"
                        (blur)="tierUpdatedEvent(i)"
                      />
                      <div *ngIf="!workflowItem.value.count" class="dynamic-form-field__validation--input">
                        <p class="dynamic-form-field__validation-text--input text-danger font-sm mb-0" role="alert">
                          {{genericVisuals?.required}}
                        </p>
                      </div>
                    </span>
                    @if (!lst) {
                      <span class="col-sm-2 centered-content">
                        <ng-select
                          [items]="lookups.logicalConditions"
                          bindLabel="text"
                          bindValue="text"
                          [searchable]="false"
                          formControlName="rule"
                          (change)="tierUpdatedEvent(i)"
                          [readonly]="isReadOnly"
                        >
                        </ng-select>
                      </span>
                    }
                    <span class="col-sm-1 centered-content">
                      @if (!isReadOnly) {
                        <i
                          class="mdi mdi-minus-circle-outline mdi-16px"
                          tooltip="Remove group"
                          (click)="removeWorkflowClick(i,j)"
                        ></i>
                      }
                    </span>
                  </div>
                  <div class="row p-0 m-0">
                    <span class="col-sm-12 centered-content">
                      @if (!isReadOnly) {
                        <i
                          class="mdi mdi-plus-circle-outline mdi-16px"
                          [ngStyle]="{'color': (editForm.value.policyConfig.tiers[i]?.workflow.length == 0) ? 'red' : null}"
                          tooltip="Add group"
                          (click)="addWorkflowClick(i)"
                        ></i>
                      }
                    </span>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="dynamic-grid__table-body-col--count centered-content">
                  @if (!isReadOnly) {
                    <i class="mdi mdi-plus-circle-outline mdi-16px" tooltip="Add Tier" (click)="addTiersClick()"></i>
                  }
                </td>
                <td class="dynamic-grid__table-body-col--count"></td>
                <td class="dynamic-grid__table-body-col--count"></td>
                <td class="dynamic-grid__table-body-col--count"></td>
                <td class="dynamic-grid__table-body-col--count"></td>
                <td class="dynamic-grid__table-body-col--count"></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </form>
  <div class="row" *ngIf="componentCurrCd != 'DEFAULT' && !isReadOnly">
    <div class="col-12">
      <button (click)="removeClick()" class="btn btn-danger" type="button">
        {{visuals?.removeWorkflowForCurr}} {{this.componentCurrCd}}
      </button>
    </div>
  </div>
</div>
